import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0c10] border-t border-white/5 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/77dafed2-8a02-43c0-b018-8b570d66b00c.png"
                alt="K・S Capital Logo"
                className="h-8 w-auto object-contain"
              />
              <span className="text-white font-bold text-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
                K・S <span className="text-[#38bdf8]">Capital</span>
              </span>
            </div>
            <p className="text-gray-300 text-[15px] leading-relaxed mb-3">
              クラウド型経理代行システムで<br />
              企業の業務効率化を支援します。
            </p>
            <p className="text-gray-400 text-sm">
              〒174-0065 東京都板橋区小豆沢3-3-4-305
            </p>
          </div>

          {/* Links 1 */}
          <div>
            <h4 className="text-white text-[15px] font-semibold mb-4 tracking-wider uppercase">Navigation</h4>
            <ul className="space-y-2">
              {[
                { label: 'ホーム', id: 'home' },
                { label: '会社概要', id: 'about' },
                { label: 'サービス', id: 'services' },
                { label: '特徴', id: 'features' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-gray-300 hover:text-[#38bdf8] text-[15px] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Links 2 */}
          <div>
            <h4 className="text-white text-[15px] font-semibold mb-4 tracking-wider uppercase">Legal</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollTo('contact')}
                  className="text-gray-300 hover:text-[#38bdf8] text-[15px] transition-colors cursor-pointer whitespace-nowrap"
                >
                  お問い合わせ
                </button>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-[#38bdf8] text-[15px] transition-colors whitespace-nowrap"
                >
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-sm">
            © 2024 K・S Capital LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
